import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UtilityService } from '../../services/utility.service';
import { CommonModule, NgFor } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { TooltipModule } from 'ng2-tooltip-directive';
import { BsDatepickerConfig, BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { EventsClassifications } from '../../Models/events';

@Component({
  selector: 'app-view-case',
  imports: [CommonModule, ReactiveFormsModule, FormsModule, NgFor
    , BsDatepickerModule, TooltipModule, AutocompleteLibModule, NgMultiSelectDropDownModule],
  templateUrl: './view-case.component.html',
  styleUrl: './view-case.component.css'
})
export class ViewCaseComponent {

  bsConfig!: Partial<BsDatepickerConfig>;
  classificationList: EventsClassifications[] = [];
  loading: boolean = false;
  FleetId = localStorage.getItem('FleetId');
  fleetList: any[] = [];
  selectedFleet: any;
  selectedFleet1: any;
  mediaTypes = [
    { label: 'Assets', value: 'assets', icon: 'far fa-folders' },
    { label: 'Media', value: 'media', icon: 'far fa-photo-video' },
    { label: 'Node', value: 'node', icon: 'fal fa-folder-plus' }
  ];
  alertId: string = '';

  requestDate: Date = new Date();
  requestTime: string = '';

  isDragging = false;
  uploadedFiles: File[] = [];
  vrnList: any;

  requestVRN = '';
  selectedMediaType = 'assets'; // default
  selectedUploadMethod = 'upload'; 
  selectMediaType(type: string): void {
    this.selectedMediaType = type;
    if (type === 'media') {
      this.selectedUploadMethod = 'alert';
    } else {
      this.selectedUploadMethod = 'upload';
    }
  }

  constructor(private route: ActivatedRoute,private utility: UtilityService, private http: HttpClient,
    private toaster: ToastrService, private titleService: Title, private router: Router) {

  }
  ngOnInit(): void {
    const caseId= this.route.snapshot.paramMap.get('caseId');
    // console.log("view case comp is called", caseId);

    this.getFleetVehicles(this.FleetId);
    this.loadFleetList(0);
    this.getEventsClassifications();

  }
  fetchAlertData() {
    if (this.alertId.trim()) {
      console.log('Fetching alert data for:', this.alertId);
    }
  }
  backToCategories() {
    this.router.navigate(['/home/incidents-events']);
  }

  getFleetVehicles(Id) {
    this.loading = true;
    this.utility.getVehicles(this.FleetId, (vehicles) => {
      const fleetVehicles = vehicles.filter(v => v.FleetId == this.FleetId);
      this.vrnList = fleetVehicles;
      /*     const allowedVrns = ['DX19XGL', 'FP68YGV'];
           this.vehiclesList = vehicles
             .filter(v => allowedVrns.includes(v.VRN))
             .map(v => ({
               VRN: v.VRN,
               VehicleId: v.VehicleId,
               FleetId: v.FleetId,
               FleetName: v.FleetName,
               DeviceIdentifier: v.DeviceIdentifier
             }));*/
      this.loading = false;
      this.requestVRN = this.vrnList[0]?.DeviceIdentifier || '';
      console.log(this.vrnList);
    });
  }
  openShareModal(): void {
    this.selectedMediaType = '';
    this.alertId = '';
  }


  onInputChange(event: any): void {
    const inputValue = event.target.value;
    console.log('Alert ID changed:', inputValue);
  }
  loadFleetList(id: number) {
    this.loading = true;
    this.utility.getFleetList(id).subscribe({
      next: (data: any[]) => {
        //this.selectedFleet = data;
        this.loading = false;
        this.fleetList = data.filter(item => item.StatusId !== 4);
        this.selectedFleet = this.fleetList.find(item => item.Id == this.FleetId);
      
        this.selectedFleet = this.FleetId;
        console.log(this.fleetList);
      },
      error: err => {
        console.error('Error fetching fleet list:', err);
      }
    });
  }
  getEventsClassifications() {
    this.loading = true;
    this.utility.getEventClassifications(this.FleetId).subscribe((data: any) => {
      this.classificationList = data;
      this.loading = false;
      this.classificationList = data;
      console.log(this.classificationList);
    });

  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    this.isDragging = true;
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    this.isDragging = false;
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    this.isDragging = false;
    if (event.dataTransfer?.files?.length) {
      this.uploadedFiles = Array.from(event.dataTransfer.files);
      console.log('Files dropped:', this.uploadedFiles);
    }
  }

  onFilesSelected(event: any): void {
    const files: FileList = event.target.files;
    if (files?.length) {
      this.uploadedFiles = Array.from(files);
      console.log('Files selected:', this.uploadedFiles);
    }
  }

}
